import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNav from '../Dashboard/SideNav';
import Navbar from '../Dashboard/Navbar';
import '../Dashboard/styles.css';

export default function User() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

 const fetchUsers = () => {
    axios.get('https://journey-scape-main.vercel.app/api/auth/users')
      .then(response => {
        setUsers(response.data.users);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleDeleteUser = (userId) => {
    axios.delete(`https://journey-scape-main.vercel.app/api/auth/users/${userId}`)
      .then(response => {
        console.log(response.data.message);
        fetchUsers(); // Refresh the user list after deletion
      })
      .catch(error => {
        console.error(error);
      });
  };

  return (
    <>
      <Navbar />
      <SideNav />
      <div className="db-info-wrap">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-box table-opp-color-box">
              <h4>User List</h4>
              <p>Number of users that are registered into JourneyScape Website.</p>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      
                      <th>Name</th>
                      <th>Email</th>
                      
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(user => (
                      <tr key={user._id}>
                        
                        <td>
                          
                            <span className="list-name">{user.name}</span>
                          
                        </td>
                        <td>{user.email}</td>
                        
                        <td>
                          <span className="badge bg-danger" onClick={() => handleDeleteUser(user._id)}>
                            <i className="far fa-trash-alt" />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
